/**
 * Open collapse on window load
 */

const detailFilter = () => {
  const detailContent = document.querySelector('.js-detailfilter') as HTMLElement;
  const resultList = document.querySelector('.js-detail-resultlist');

  if (detailContent && resultList) {
    window.addEventListener('scroll', function () {
      if (window.pageYOffset >= 300) {
        resultList.classList.add('active');
      } else {
        resultList.classList.remove('active');
      }
    });
  }
};

export default detailFilter;
